/**
 * Calculates tabindex and returns it
 * "none" returns -1
 * @param tab
 */
const staticTabSequence = [
  "logo",
  "searchIcon",
  "iconPDF",
  "iconLanguage",
  "iconCart",
  "IconShare",
  "shareDownload",
  "sharePrint",
  "shareShare",
  "sitemap",
  "search",
  "pagePicker",
  "pageControl",
  "zoomControl",
  "fullScreen",
  "infoLink",
  "languageLink",
  "navStart",
  "navCategory",
  "navFavorites",
  "categoryListItem",
  "breadcrumbBack",
  "previewCover",
  "previewPages",
  "editionDetailButtonBlue",
  "editionDetailButtonFavorites",
  "editionDetailMoreButton",
  "overviewShowAll", 
  "cartLink",
  "cartLinkFavorites",
  "kioskOverviewCartLink",
];

const sameAsPrevious = new Set(["iconPDF", "iconCart", "breadcrumbBack"]);
const dynamicPrefixes = ["overviewShowAll", "cartLink"];

const dynamicTabList: string[] = [];

const isDynamicTab = (tab: string): boolean =>
  dynamicPrefixes.some((prefix) => tab.startsWith(prefix) && /\d+$/.test(tab));

export const getTabindex = (tab: string): number => {
  if (tab === "none") return -1;

  // Wenn es ein dynamischer Tab ist und noch nicht registriert wurde → merken
  if (isDynamicTab(tab) && !dynamicTabList.includes(tab)) {
    dynamicTabList.push(tab);
  }

  const fullTabSequence = [...staticTabSequence, ...dynamicTabList];

  let currentIndex = 0;
  const tabIndexMap = new Map<string, number>();

  for (let i = 0; i < fullTabSequence.length; i++) {
    const currentTab = fullTabSequence[i];

    if (sameAsPrevious.has(currentTab)) {
      const prevTab = fullTabSequence[i - 1];
      tabIndexMap.set(currentTab, tabIndexMap.get(prevTab) ?? currentIndex);
    } else {
      currentIndex++;
      tabIndexMap.set(currentTab, currentIndex);
    }
  }

  return tabIndexMap.get(tab) ?? -1;
};
